export enum CONFIRMATION_TYPES {
    SHORT = 'B',
    NORMAL = 'N',
}
